<template>
  <div class="faq">
    <div class="faq-question-s" v-b-toggle.q52>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q52.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q52')}}</b-col>
      </b-row>
      <b-collapse id="q52">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A52.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a52-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q53>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q53.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q53')}}</b-col>
      </b-row>
      <b-collapse id="q53">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A53.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a53-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q54>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q54.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q54')}}</b-col>
      </b-row>
      <b-collapse id="q54">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A54.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a54-1')}}</div>
            <br/>
            <div>{{$t('a54-2')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q55>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q55.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q55')}}</b-col>
      </b-row>
      <b-collapse id="q55">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A55.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a55-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q56>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q56.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q56')}}</b-col>
      </b-row>
      <b-collapse id="q56">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A56.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a56-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q57>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q57.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q57')}}</b-col>
      </b-row>
      <b-collapse id="q57">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A57.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a57-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q58>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q58.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q58')}}</b-col>
      </b-row>
      <b-collapse id="q58">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A58.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a58-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirectLogin() {
      this.$router.push({ name: 'Login' });
    }
  }
};
</script>

<i18n src="@/public/locales/modules/faq/components/FaqWorkspace.json" />